import React from 'react';

interface WidgetLoadingStateProps {
  /** Optional message below the spinner */
  message?: string;
  /** Spinner diameter: sm=20px, md=32px, lg=40px */
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const spinnerSizes: Record<'sm' | 'md' | 'lg', string> = {
  sm: 'h-5 w-5',
  md: 'h-8 w-8',
  lg: 'h-10 w-10',
};

const WidgetLoadingState: React.FC<WidgetLoadingStateProps> = ({
  message,
  size = 'md',
  className = '',
}) => (
  <div className={`h-full flex items-center justify-center p-4 ${className}`}>
    <div className="text-center">
      <div
        className={`animate-spin rounded-full ${spinnerSizes[size]} border-2 border-neutral-200 border-t-primary-600 mx-auto`}
      />
      {message && (
        <p className="mt-3 text-sm font-medium text-neutral-500">{message}</p>
      )}
    </div>
  </div>
);

export default WidgetLoadingState;
